import React, {useState, useMemo, useEffect} from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Container, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { DeleteConfirm } from './DeleteConfirm';
import { isArray, isFunction } from "lodash";
import { epochToDateTime } from "../../shared/functions/toDateTime";

import { Divider } from '@mui/material'

import ItemPriceReport from "./ItemPriceReport";
import ItemStat from "./ItemStat";
import useFamily from "../../hooks/useFamily";
import { gfDate, gfDatetime } from '../../utils/formatTime';
import useRoles from '../../hooks/useRoles';
import {itemsCollection} from 'src/constant/firestore';
import color from "color";

const useModalStyles = makeStyles((theme) => ({

    fontStyle: { fontWeight: 'bold', fontFamily: 'Times New Roman' },
    spaceStyle: { display: 'flex', justifyContent: 'space-between' },
    centerStyle: { textAlign: 'center' },
    imageStyle: { width: "400px", height: "400px", float: "left" },
    contentStyle: { float: "left", width: "450px" },

}));


const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);


const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);


export const ItemDetails = (props) => {


    const [selected, setSelected] = useState();

    const [itemVendorInfo, setItemVendorInfo] = useState([]);

    const [openStat, setOpenStat] = useState(false);

    const [openReport, setOpenReport] = useState(false);
    const [sameFamily, setSameFamily] = useState([]);



    const handleOpenReport = () => setOpenReport(true)

    const handleCloseReport = () => setOpenReport(false)

    const handleOpenStat = () => setOpenStat(true)

    const handleCloseStat = () => setOpenStat(false)

    const classes = useModalStyles();
    const [canDelete, setCandelete] = useState(false);
    const { open, setOpen, item, onClose } = props;
    const navigation = useHistory();

    const { list, } = useFamily();
    const { userRole, isLoading } = useRoles();
    useEffect(() => {
        return () => {
            if(item.FamilyCode){
                const query = itemsCollection.where('FamilyCode', '==', item.FamilyCode);

                query.get().then((querySnapshot) => {
                    const collections = querySnapshot.docs.map((doc) => doc.data());
                    setSameFamily(collections)
                }).catch((error) => {
                    console.log('Error getting collections:', error);
                });
            }

        };
    }, [item.FamilyCode,list]);

    const family = useMemo(() => { 
        
        var info = []

        for(var key in item.Vendors){  

            info.push({
                "VendorName": item.Vendors[key].Name,
                "ItemCode": item.Vendors[key].ItemCode,
            })
            setItemVendorInfo(info)  
        }
        return list?.find(one => one?.code === item?.FamilyCode)
    }, [item?.FamilyCode,list])




    function handleClose() {
        isFunction(setOpen) && setOpen(false)
        isFunction(onClose) && onClose()
    }

    function hadnleEdit() {
        navigation.push('/update-item', item)
    } 

    const handlePriceReport = () => {
        setSelected(item?.Vendors)
        handleOpenReport()
    }

    const handleStat = () => {
        setSelected(item?.InternalId)
        handleOpenStat()
    }




    return (
        <>
            <div>
                <Dialog fullWidth maxWidth="md" onClose={handleClose}
                    aria-labelledby="customized-dialog-title" open={open}>

                    <DialogActions style={{ justifyContent: "space-between" }}>
                        <Typography>{item.Name}</Typography>

                        <div>
                            { userRole?.Admin !== true && userRole?.ItemEditor !== true ? ""
                                :
                                <Button onClick={hadnleEdit} color="primary" variant="contained">
                                    Edit
                                </Button>

                            }

                            {" "}

                            { userRole?.Admin !== true && userRole?.ItemDeleting !== true ? ""
                                :
                                <Button onClick={() => setCandelete(true)} color="secondary" variant="contained">
                                    Delete
                                </Button>

                            }
                            { " "}
                            {<Button onClick={handlePriceReport} color="primary" variant="contained">
                                Price report
                            </Button>
                            }
                            { " " }
                            {
                                <Button onClick={handleStat} color="primary" variant="contained">
                                    Statistique
                                </Button> 
                            }
                            {" "}
                            {
                                <Button onClick={handleClose} color="secondary" variant="outlined">
                                    Fermer
                                </Button>
                            }
                        </div>
                    </DialogActions>

                    <DialogContent dividers>
                        <Container maxWidth="lg" className={classes.spaceStyle}>
                            <div className={classes.imageStyle}>
                                <img src={item.ImageUrl} width="100%" height="100%" alt={item.Name} />
                            </div>
                            <div className={classes.contentStyle}>

                                <Typography>Classe : {item?.ItemClsass}</Typography>
                                <Typography>Famille : {family?.label}</Typography>
                                <Typography>RefEquivalence : {item?.RefEquivalence}</Typography>
                                <Typography>Categorie : {item.Categorie?.Label}</Typography>
                                <Typography>Sous Categorie : {item.Categorie?.SubCategorie?.Label}</Typography>
                                <Typography>UPC: {item.UPC}</Typography>
                                <Typography>Prosoft Reference : {item.InternalId}</Typography>
                                <Typography>Quantity In PO : {item.QuantityInPO}</Typography>
                                <Typography>Quantity In Shipping : {item.QuantityInShpping}</Typography>
                                <br />

                                <Divider />

                                <Typography style={{ fontWeight: 'bold' }}>
                                    Dekon
                                </Typography>

                                <Typography>
                                    Quantite : {item?.Stores?.Dekon?.Quantity || item.Stock?.Dekon || 0}
                                </Typography>

                                <Typography>
                                    Prix de vente : {item?.Stores?.Dekon?.SalePrice || 'N/A'}
                                </Typography>

                                <Typography>
                                    Derniere vente : {gfDate(item?.Stores?.Dekon?.SaleDate) || 'N/A'}
                                </Typography>

                                <Typography>
                                    Derniere recption : {gfDate(item?.Stores?.Dekon?.ReceptionDate) || 'N/A'}
                                </Typography>

                                <Typography>
                                    Derniere sync : {gfDate(item?.Stores?.Dekon?.LastSyncAt) || 'N/A'}
                                </Typography>


                                <Divider />
                                <br />

                                <Typography style={{ fontWeight: 'bold' }}>
                                    Cassablanca
                                </Typography>

                                <Typography>
                                    Quantite : {item?.Stores?.Cassablanca?.Quantity || item.Stock?.Cassablanca || 0}
                                </Typography>

                                <Typography>
                                    Prix de vente : {item?.Stores?.Cassablanca?.SalePrice || 'N/A'}
                                </Typography>

                                <Typography>
                                    Derniere vente : {gfDate(item?.Stores?.Cassablanca?.SaleDate) || 'N/A'}
                                </Typography>

                                <Typography>
                                    Derniere recption : {gfDate(item?.Stores?.Cassablanca?.ReceptionDate) || 'N/A'}
                                </Typography>

                                <Typography>
                                    Derniere sync : {gfDate(item?.Stores?.Cassablanca?.LastSyncAt) || 'N/A'}
                                </Typography>

                                <Divider />
                                <br />

                                <Typography style={{ fontWeight: 'bold' }}>
                                    Sale Price info
                                </Typography>

                                <Typography>
                                    User : {item?.SalePriceMutator?.User?.UserName || 'N/A'}
                                </Typography>

                                <Typography>
                                    Sale price : {item?.SalePriceMutator?.NewSalePrice || 'N/A'}
                                </Typography>

                                <Typography>
                                    Change type : {item?.SalePriceMutator?.Type || 'N/A'}
                                </Typography>

                                <Typography>
                                    Mutation date  : {gfDatetime(item?.SalePriceMutator?.Date) || 'N/A'}
                                </Typography>

                                <Divider />
                                <br />

                                <Typography>Buy Price : $ {item?.LastBuyPrice}  </Typography>
                                {/* <Typography>Sell Price*/}
                                {/*    : {item?.SellPrice || item?.Price || item?.NewPrice || 0} FCFA </Typography>*/}
                                {/*<Typography>Stock Price : {item?.NewPrice} FCFA </Typography>*/}

                                {/*<Typography>Last sold*/}
                                {/*    : {item?.LastBuyDate && epochToDateTime(item?.LastBuyDate)}   </Typography>*/}
                                {/*<Typography>Reception*/}
                                {/*    Date: {item?.ReceptionDate && epochToDateTime(item?.ReceptionDate)}   </Typography> */}
                                {/* <Typography>Updated by: {item?.LastUpdatedBy?.UserName}   </Typography> */}
                                <Typography>Updated by: {item?.SalePriceMutator?.User?.UserName || 'N/A'}  </Typography>
                                <Typography>Updated
                                    at: {item?.LastUpdatedBy?.UpdateAt && epochToDateTime(item?.LastUpdatedBy?.UpdateAt)}   </Typography>
                                <Typography>Updated
                                    data: {item?.LastUpdatedBy?.ItemFieldUpdated?.toString()}   </Typography> 

                                <br/> 
                                <Typography style={{ fontWeight: 'bold' }}>Description:</Typography>
                                <Typography>{item?.Description ?? "N/A"}   </Typography>
                                <br/>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <Typography>Produit périssable : {item.IsExpirationDateRequire ?
                                        <span style={{
                                            backgroundColor: "green",
                                            color: "white",
                                            padding: "5px",
                                            borderRadius: 20
                                        }}>OUI</span> :
                                        <span style={{
                                            backgroundColor: "red",
                                            color: "white",
                                            padding: "5px",
                                            borderRadius: 20
                                        }}>NON</span>}
                                    </Typography>

                                    <Typography>Produit Validé : {item.IsProductValidated ?
                                        <span style={{
                                            backgroundColor: "green",
                                            color: "white",
                                            padding: "5px",
                                            borderRadius: 20
                                        }}>OUI</span> :
                                        <span style={{
                                            backgroundColor: "red",
                                            color: "white",
                                            padding: "5px",
                                            borderRadius: 20
                                        }}>NON</span>}
                                    </Typography>
                                </div>
                                <br/>
                                <div>

                                </div>
                                <br />
                                {
                                    isArray(item?.ChildItems) && item?.ChildItems?.map((e, i) => (
                                        <div key={i} style={{
                                            float: "left",
                                            margin: "10px",
                                            height: "70px",
                                            display: "flex",
                                            justifyContent: "space-between"
                                        }}>
                                            <img src={e.ImageUrl} width="70px" height="70px" alt="" />
                                            <span style={{
                                                textAlign: "center",
                                                fontWeight: 'bold',
                                                fontSize: "20px",
                                                marginRight: '10px'
                                            }}>{e.Quantity}</span>
                                            <span style={{
                                                textAlign: "center",
                                                alignContent: "center",
                                                marginTop: '30px'
                                            }}>{e.Name}</span>
                                        </div>
                                    ))
                                }

                                {
                                    isArray(item?.ChildItems?.ChildItems) && item?.ChildItems?.ChildItems?.map((e, i) => (
                                        <div key={i} style={{
                                            float: "left",
                                            margin: "10px",
                                            height: "70px",
                                            display: "flex",
                                            justifyContent: "space-between"
                                        }}>
                                            <img src={e.ImageUrl} width="70px" height="70px" alt="" />
                                            <span style={{
                                                textAlign: "center",
                                                fontWeight: 'bold',
                                                fontSize: "20px",
                                                marginRight: '10px'
                                            }}>{e.Quantity}</span>
                                            <span style={{
                                                textAlign: "center",
                                                alignContent: "center",
                                                marginTop: '30px'
                                            }}>{e.Name}</span>
                                        </div>
                                    ))
                                }
                                
                                <br />
                                {

                                    isArray(sameFamily) && sameFamily?.map((e, i) => (
                                        <div key={i} style={{
                                            float: "left",
                                            margin: "10px",
                                            height: "70px",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            flexDirection: "row"
                                        }}>
                                            <img src={e.ImageUrl} width="70px" height="70px" alt="" />
                                            <div style={{
                                                display: "flex",
                                                position: "relative",
                                                flexDirection: "column",
                                                justifyContent: 'center'
                                            }}>
                                                <span style={{
                                                    position: "absolute",
                                                    top: -20,
                                                    left: -10,
                                                    textAlign: "center",
                                                    fontWeight: 'bold',
                                                    fontSize: "15px",
                                                    background: '#284905',
                                                    padding: '10px',
                                                    borderRadius: '40px',
                                                    width: 'max-content',
                                                    color: 'white'
                                                }}>{e.QuantityAvailable}</span>
                                                <span style={{
                                                    textAlign: "center",
                                                    alignContent: "center",
                                                    marginTop: '5px'
                                                }}>{e.Name}</span>
                                            </div>

                                        </div>
                                    ))
                                }

                                <br />
                                {
                                isArray(itemVendorInfo) && itemVendorInfo.map((e, i) => (
                                    
                                            <div key={i} style={{
                                                float: "left",
                                                margin: "10px",
                                                height: "70px", 
                                                justifyContent: "space-between"
                                            }}>
                                                <span style={{
                                                    textAlign: "center",
                                                    fontWeight: 'bold',
                                                    fontSize: "20px",
                                                    marginRight: '10px'
                                                }}>{e.VendorName}</span> 
                                                <br /> 
                                                <Typography>Item Code : { e.ItemCode }</Typography>
                                            </div>
                                ) )
                                }
                            </div>

                        </Container>
                    </DialogContent>

                </Dialog>
            </div>
            {
                canDelete && <DeleteConfirm open={canDelete} setOpen={setCandelete} setParent={setOpen} id={item.id} />
            }

            {
                openReport && (
                    <ItemPriceReport open={openReport} onClose={handleCloseReport} selected={selected} />
                )
            }

            {
                openStat && (
                    <ItemStat open={openStat} onClose={handleCloseStat} selected={selected} />
                )
            }

        </>
    );
}
